var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadCvCloudIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_130_6",
    "data-name": "Component 130 \\u2013 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.029,
    height: 24.453,
    viewBox: "0 0 38.029 24.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10841",
    "data-name": "Path 10841",
    d: "M63.084,122.291c0-.1.017-.2.017-.306A9.9,9.9,0,0,0,53.277,112a9.793,9.793,0,0,0-8.856,5.689,5.03,5.03,0,0,0-2.275-.552,5.094,5.094,0,0,0-4.992,4.288A7.737,7.737,0,0,0,39.6,136.453H63.093a7.083,7.083,0,0,0-.008-14.162Z",
    transform: "translate(-32 -112)",
    fill: "#a5a5a5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "down_arrow",
    "data-name": "down arrow",
    d: "M961.542,35.271V30h-5.271v5.271H951l7.683,7.835,8.13-7.835Z",
    transform: "translate(977.921 50.133) rotate(-180)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCvCloudIcon);
export default __webpack_public_path__ + "static/media/upload-cv-cloud-icon.eeb8a347f8226ba4cd32aea3dd8b001c.svg";
export { ForwardRef as ReactComponent };